import styled from 'styled-components';
import {useLogout} from '@/api/session';
import {Button} from '@/components/Button';
import {Typography} from '@/components/Typography';
import {useSession} from '@/hooks';
import {PaddingBox} from '@/styled-components';
import {palette} from '@/styles';

export const UserSection = () => {
  const {hasSession, user} = useSession();
  const {mutate: logout} = useLogout();

  if (hasSession && user) {
    return (
      <Root>
        <Typography variant="medium16" color={palette.textPrimary} as="div">
          <strong>{user.nickname}</strong>
        </Typography>
        <PaddingBox top={4}>
          <Typography variant="medium12" color={palette.textSecondary}>
            {user.email}
          </Typography>
        </PaddingBox>
        <PaddingBox top={24}>
          <Button
            variant="ghost"
            size="small"
            color="black"
            noPadding
            onClick={logout}
          >
            로그아웃
          </Button>
        </PaddingBox>
      </Root>
    );
  }

  return null;
};

const Root = styled.div``;
